import { render, staticRenderFns } from "./add-prospect.vue?vue&type=template&id=2320a7a0&"
import script from "./add-prospect.vue?vue&type=script&lang=js&"
export * from "./add-prospect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports